import styled from 'styled-components';

import { Text } from '@atom/typography/typography';
import { Form } from '@form/common.style';

export const Label = styled(Form.Item)`
  & .ant-form-item-label {
    text-align: start;
    font-weight: 600;
    min-width: 160px;
  }
`;

export const RedirectText = styled(Text)`
  padding-left: 12px;
`;
